export const COUNTRY_NAME_TO_CODE: Record<string, string> = {
  USA: 'US',
  'UNITED STATES': 'US',
  'UNITED STATES OF AMERICA': 'US',
  'UNITED KINGDOM': 'GB',
  UK: 'GB',
  GBR: 'GB',
  'GREAT BRITAIN': 'GB',
  CHINA: 'CN',
  INDIA: 'IN',
  VIETNAM: 'VN',
  INDONESIA: 'ID',
  NETHERLANDS: 'NL',
  HOLLAND: 'NL',
  FRANCE: 'FR',
  BELGIUM: 'BE',
  BEL: 'BE',
  BELGIE: 'BE',
  BRAZIL: 'BR',
  BRASIL: 'BR',
  BRA: 'BR',
  ITALY: 'IT',
  ITALIA: 'IT',
  ITA: 'IT',
  ARGENTINA: 'AR',
  BANGLADESH: 'BD',
  KOREA: 'KR',
  'SOUTH KOREA': 'KR',
  KOR: 'KR',
  MALAYSIA: 'MY',
  MYS: 'MY',
  MEXICO: 'MX',
  MEX: 'MX',
  NEPAL: 'NP',
  NPL: 'NP',
  NIGERIA: 'NG',
  NGA: 'NG',
  PAKISTAN: 'PK',
  PAK: 'PK',
  PERU: 'PE',
  PER: 'PE',
  POLAND: 'PL',
  POL: 'PL',
  'SAUDI ARABIA': 'SA',
  KSA: 'SA',
  SAU: 'SA',
  'SOUTH AFRICA': 'ZA',
  RSA: 'ZA',
  ZAF: 'ZA',
  THAILAND: 'TH',
  THA: 'TH',
  TURKEY: 'TR',
  TÜRKIYE: 'TR',
  TUR: 'TR',
  UGANDA: 'UG',
  UGA: 'UG',
  URUGUAY: 'UY',
  URY: 'UY',
  UAE: 'AE',
  'UNITED ARAB EMIRATES': 'AE',
  ARE: 'AE',
};

export function normalizeCountryCode(v: unknown): string {
  let s = '';
  if (typeof v === 'string') s = v;
  else if (typeof v === 'number' || typeof v === 'boolean' || typeof v === 'bigint') s = String(v);
  else return '';

  const up = s.trim().toUpperCase();
  if (!up) return '';
  return COUNTRY_NAME_TO_CODE[up] ?? up;
}
